import { Box, Typography, Button, Card, CardContent, Paper, FormControl, InputLabel, Checkbox, FormControlLabel,
  FormLabel,
  TextField,
  List,
  ListItem, } from '@mui/material';
import StorageIcon from "@mui/icons-material/Storage";
import ArticleIcon from "@mui/icons-material/Article";
import SecurityIcon from "@mui/icons-material/Security";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import { useState } from 'react';
import Grid from "@mui/material/Grid2";
import SchemaGen from './NavApp/SchemaGen';
import MagicIcon from "@mui/icons-material/AutoFixHigh";
import WorkflowPage from './NavApp/Workflow/workflow';




export const tabs = [
  { label: 'Schema Generation', icon: <StorageIcon />, route: '/schema' },
  { label: 'Page Builder', icon: <ArticleIcon />, route: '/pagebuilder' },
  { label: 'Roles & Permissions', icon: <SecurityIcon />, route: '/roles' },
  { label: 'Workflow Automation', icon: <AutoAwesomeIcon />, route: '/workflow' },
  { label: 'Deploy & Test', icon: <RocketLaunchIcon />, route: '/deploy' },
];

export const dynamicMenus = tabs.map((tab) => ({
  menuName: tab.label,
  icon: tab.icon, 
  route: tab.route,
}));

function SchemaGeneration() {
  return <Typography>Define entities and relationships for invoices, clients, and payments.</Typography>;
}




function RolesPermissions() {
}

function WorkflowAutomation() {
}

function DeployTest() {
}

export default function AddApp() {
  const [activeTab, setActiveTab] = useState(0);
  const [aiPrompt, setAiPrompt] = useState("");

  const [aiGeneratedSteps, setAiGeneratedSteps] = useState(null);
  const generateSteps = () => {
    setAiGeneratedSteps([
      "1. Define the data model for your application.",
      "2. Build dynamic pages with forms and tables.",
      "3. Assign roles and permissions for secure access control.",
      "4. Automate workflows for efficiency.",
      "5. Deploy, test, and optimize your system."
    ]);
  };
  const [filterText, setFilterText] = useState("");

  const handleFilterChange = (event) => {
    setFilterText(event.target.value);
  };

  const generateSchemaFromAI = () => {}


  return (
    <Box p={4} textAlign="center">
      <Typography variant="h4" fontWeight={700} mb={1}>Invoice Management System</Typography>
      <Typography variant="subtitle1" mb={4} color="text.secondary">
        Configure and automate your invoice workflow seamlessly
      </Typography>

      <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
              <Typography variant="h6" fontWeight="bold" sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <MagicIcon color="primary" /> AI-Powered Schema Generator
              </Typography>
            
              {/* Form Control for AI Prompt */}
              <FormControl fullWidth sx={{ mt: 2 }}>
              <TextField
                fullWidth
                multiline
                rows={5} 
                placeholder="Describe your application functionality..."
                value={aiPrompt}
                onChange={(e) => setAiPrompt(e.target.value)}
                sx={{ 
                  "& .MuiInputBase-root": { minHeight: "150px" } 
                }}
              />
            </FormControl>


  <Button
    variant="contained"
    onClick={generateSteps}
    sx={{ mt: 2,backgroundColor:"#2FB354"}}
  >
    Generate Schema
  </Button>
</Paper>
{aiGeneratedSteps && (
  <Box sx={{ bgcolor: "#f9fafb", p: 3, borderRadius: 2, boxShadow: 3 }}>
    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
      <Typography variant="h6" fontWeight={600} color="text.primary">
        AI-Generated Steps
      </Typography>
      <TextField
        label="Filter Steps"
        variant="outlined"
        size="small"
        onChange={(e) => setFilterText(e.target.value)}
      />
    </Box>
    <List sx={{ mt: 2, listStyle: "none", pl: 3 }}>
      {aiGeneratedSteps
        
        .map((step, index) => (
          <ListItem key={index} sx={{ display: "list-item", color: "text.secondary" }}>
            {step}
          </ListItem>
        ))}
    </List>
  </Box>
)}



      
      {/* <Box sx={{ boxShadow: 3, borderRadius: 3, p: 4 }}>
        <Grid container spacing={3}  sx={{ width: "100%",p:0}}>
          {tabs.map((tab, index) => (
            <Grid size={2.3} key={index}>
              <Box
                onClick={() => setActiveTab(index)}
                sx={{
                  boxShadow: activeTab === index ? 6 : 3,
                  p: 3,
                  borderRadius: 2,
                  textAlign: "center",
                  height: 80,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "0.3s",
                  cursor: "pointer",
                  backgroundColor: activeTab === index ? "#2FB354" : "white",
                  color: activeTab === index ? "white" : "inherit",
                }}
              >
                {tab.icon}
                <Typography fontWeight="bold" mt={1}>
                  {tab.label}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box> */}

    {/* <Box sx={{ boxShadow: 3, borderRadius: 3, p: 4,mt:4 }}>
     {tabs[activeTab].content}

     </Box> */}
      
    </Box>
  );
}